import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class HighlightConfig extends Model {
  [Type] = 'roi-trophies/highlight-config' as const;

  @attr('boolean') declare emailEnabled: boolean;
}
